<div class="sticky top-0 right-0 w-full h-4rem surface-overlay relative">

  <p-message *ngIf="!isProduction" severity="error" text="DEVELOPMENT INSTANCE, FOR DEVELOPMENT PURPOSES ONLY" styleClass="w-full h-full flex justify-content-start ml-7"></p-message>

  <!-- Calendar - Absolutely centered -->
  <div *ngIf="isDispatchDashboard()" class="absolute w-full flex justify-content-center align-items-center"
    style="top: 50%; transform: translateY(-50%);">
    <div class="flex align-items-center gap-1">
      <i class="pi pi-chevron-left cursor-pointer" (click)="previousDay()"></i>
      <p-calendar styleClass="custom" [(ngModel)]="selectedDate" placeholder="Select Date" (onSelect)="onDateSelect()"
        (ngModelChange)="onDateSelect()" appendTo="body" (dragover)="$event.preventDefault()" (drop)="$event.preventDefault()">
      </p-calendar>
      <i class="pi pi-chevron-right cursor-pointer" (click)="nextDay()"></i>
    </div>
  </div>
  
  <!-- Left side tab menu - Only show on driver schedule page -->
  <div *ngIf="isDriverSchedule()" class="absolute pl-8 top-0 h-full flex align-items-center pl-2">
    <p-tabMenu [model]="menuItems" [(activeItem)]="activeItem" styleClass="text-sm">
    </p-tabMenu>
  </div>

  <!-- Right side elements - Absolute positioning -->
  <div class="absolute right-0 top-0 h-full flex align-items-center gap-2 pr-2 pl-2">
    <!-- Theme Button -->
    <p-button [icon]="checked ? 'pi pi-moon' : 'pi pi-sun'" [text]="true" [size]="'small'" (onClick)="toggleTheme()"
      [ngClass]="{'text-primary': checked}"></p-button>

    <!-- User Info - Mock data instead of using authService -->
    <div class="flex flex-column align-items-center">
      <span class="font-semibold">{{ userDisplayName }}</span>
      <span class="text-sm text-500">{{ userRole }}</span>
    </div>

    <!-- User Icon -->
    <p-button icon="pi pi-user" [rounded]="true" [raised]="true" severity="info"></p-button>
  </div>
</div>